<template>
<div>
  
<button class="btn primary" v-if="type === 'primary'" type="button"  v-ripple v-on:click="onBtnClick">{{ text }}
</button>
<button class="btn secondary" type="button" v-if="type === 'secondary'" v-on:click="$emit('click')">{{ text }}
</button>
</div>
</template>
<script>
export default {
  name: "tlbutton",
  props: ["text", "type"],
  methods:{
    onBtnClick(){
      setTimeout(()=>{
        this.$emit('click');
      },400)
    }
  }
};
</script>
